<template>
  <div>
    <div class="w-full flex items-center justify-center my-5">
      <!-- <NumberInputControl @typing="typing" 
                @complete="complete" 
                v-bind:length="length"
                v-bind:value="value" />. -->
      <v-otp-input
        :is-disabled="false"
        ref="pinOTP"
        input-classes="otp-input"
        input-type="number"
        inputmode="numeric"
        :num-inputs="length"
        v-model:value="value"
        :should-auto-focus="true"
        :should-focus-order="true"
        :key="otp_input_key"
        @on-complete="complete"
        @on-change="typing"
      />
    </div>
    <div class="px-4 pb-4 flex" v-if="!election">
      <ButtonControl v-on:click="validate" v-bind:disabled="disabled">
        {{ lang("lbl_0000016") }}
      </ButtonControl>
    </div>
    <div class="p-4 flex flex-row" v-else>
      <ButtonControl
        class="mr-3"
        outline
        v-on:click="$router.push('/dashboard')"
      >
        {{ lang("lbl_0000181") }}
      </ButtonControl>
      <ButtonControl v-on:click="validateElection" v-bind:disabled="disabled">
        {{ lang("lbl_0000372") }}
      </ButtonControl>
    </div>
    <div v-if="!election">
      <div v-show="show" class="pt-2 flex justify-center items-center pb-6">
        <div
          v-on:click="resend"
          v-text="lang('lbl_0000018')"
          class="text-sm leading-none underline text-primary font-semibold"
        ></div>
      </div>

      <div v-show="!show" class="pt-2 flex justify-center items-center pb-6">
        <div class="text-sm text-grey-darker">
          <span class="mr-1"> {{ this.lang("lbl_0000019") }}</span>
          <span>{{ min }}</span
          >:<span> {{ this.formatSeconds(this.sec) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonControl from "./../../components/controls/ButtonControl.vue";
import OTP from "./../../services/OTP.js";
import mixin from "./../../mixin.js";
import GA from "@/services/GA";
import VOtpInput from "vue3-otp-input";

export default {
  name: "v-otp-control",

  mixins: [mixin],

  components: {
    ButtonControl,
    VOtpInput,
  },

  props: {
    type: {
      type: Number,
      required: true,
    },
    pin: {
      type: String,
    },
    mobile: {
      type: String,
      default: null,
    },
    email: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    election: {
      type: Boolean,
      default: false,
    },
    startTimerImmediately: {
      type: Boolean,
      default: true,
    },
    startTimerOnChange: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      length: 6,
      value: "",
      disabled: true,
      show: false,
      min: 2,
      sec: 0,
      minutes: 2,
      t: null,
      otp_pin: null,
      otp_token: null,
      ga_code: this.$store.state.ga.code,
      otp_input_key: 0,
    };
  },

  mounted() {
    this.$nextTick(() => {
      const inputs = this.$el.querySelectorAll(".otp-input");

      inputs.forEach((input) => {
        input.addEventListener("keydown", this.onlyNumeric);
        input.addEventListener("input", this.sanitizeNumeric);
      });
    });

    if (this.startTimerImmediately) {
      this.resetTimer();
      this.startTimer();
    }
  },
  beforeUnmount() {
    const inputs = this.$el.querySelectorAll(".otp-input");

    inputs.forEach((input) => {
      input.removeEventListener("keydown", this.onlyNumeric);
      input.removeEventListener("input", this.sanitizeNumeric);
    });

    this.stopTimer();
  },
  watch: {
    startTimerOnChange(value) {
      if (value && !this.t) {
        this.resetTimer();
        this.startTimer();
      }
    },
  },

  methods: {
    startTimer() {
      this.stopTimer();
      this.show = false;

      this.t = setInterval(() => {
        if (this.min === 0 && this.sec === 0) {
          this.show = true;
          this.stopTimer();
          return;
        }

        if (this.sec === 0) {
          this.min--;
          this.sec = 59;
        } else {
          this.sec--;
        }
      }, 1000);
    },

    stopTimer() {
      if (this.t !== null) {
        clearInterval(this.t);
        this.t = null;
      }
    },

    resetTimer() {
      this.min = this.minutes;
      this.sec = 0;
      this.show = false;
    },

    formatSeconds(sec) {
      return sec.toString().padStart(2, "0");
    },

    typing(value) {
      const numeric_value = value.replace(/\D/g, "");

      this.value = numeric_value;
      this.disabled = numeric_value.length !== this.length;
    },

    complete(value) {
      this.value = value.replace(/\D/g, "");
    },

    validate() {
      let state = this.$store.state;

      this.$emit("showloader");

      OTP.validate(this.type, this.pin, this.value)
        .then((response) => {
          let data = response.data.data;

          if (state.forgot_pin) {
            state.reset_pin.otp_token = data.otp_token;
            state.reset_pin.otp_pin = data.otp_pin;
            this.$router.push("/user/enroll/pin");
            return;
          }

          this.$emit("success", data);
        })
        .catch((error) => {
          this.value = "";
          this.disabled = true;
          this.otp_input_key++;

          this.$emit("failed", error?.response?.data?.message || "Invalid OTP");
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },

    validateElection() {
      this.$emit("showloader");

      let state = this.$store.state;

      GA.validateOtp(this.value, this.ga_code)
        .then((response) => {
          let data = response.data.data;

          state.ga.user.secret_key = data.secret_key;

          this.$emit("success", data);
        })
        .catch((error) => {
          this.value = "";

          this.$emit("failed", error?.response?.data?.message || "Invalid OTP");
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },

    resend() {
      this.$emit("showloader");

      this.stopTimer();

      OTP.request(this.type, this.name, this.email, this.mobile, this.pin)
        .then(() => {
          this.value = "";
          this.disabled = true;
          this.otp_input_key++;

          this.resetTimer();
          this.startTimer();

          this.$emit("reload");
        })
        .catch((error) => {
          this.$emit(
            "failed",
            error?.response?.data?.message || "Failed to resend OTP",
          );
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },

    onlyNumeric(event) {
      const allowed_keys = [
        "Backspace",
        "Delete",
        "Tab",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
      ];

      if (allowed_keys.includes(event.key)) {
        return;
      }

      if (!/^[0-9]$/.test(event.key)) {
        event.preventDefault();
      }
    },

    sanitizeNumeric(event) {
      const input = event.target;
      const numericValue = input.value.replace(/\D/g, "");

      if (input.value !== numericValue) {
        input.value = numericValue;
      }
    },
  },
};
</script>
